import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

// import 'amfe-flexible';

Vue.prototype.$axios = axios

import domain_public from '../public/js/domain_public'
Vue.prototype.domain = domain_public

// 微信
// import wx from 'weixin-js-sdk'
// Vue.prototype.wx = wx
// Vue.use(wx)

Vue.config.productionTip = false

// 设置浏览器标题
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})

// 根据路由设置标题
router.beforeEach((to, from, next) => {
  /*路由发生改变修改页面的title */
  if(to.meta.title) {
    document.title = to.meta.title
  }
  next();
})

// axios.get('').then((res) => {

// })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
